export class AppInitializerCms {
    CMS_URLS: any;
}